import { render, staticRenderFns } from "./Returnrecord.vue?vue&type=template&id=7e7c3848&scoped=true"
import script from "./Returnrecord.vue?vue&type=script&lang=js"
export * from "./Returnrecord.vue?vue&type=script&lang=js"
import style0 from "./Returnrecord.vue?vue&type=style&index=0&id=7e7c3848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7c3848",
  null
  
)

export default component.exports